// This file contains logic carried over from UIComponents.
// It should not be used in new Foundations components, only for transitional components.

import { Space } from 'foundations-theming';
import { TShirtShortSizes } from '../tShirtSizes';

export type DistanceKeys = 'flush' & TShirtShortSizes;

export const DISTANCE_SIZES: Record<DistanceKeys, Space> = {
  flush: '0',
  xs: '200',
  sm: '300',
  md: '600',
  lg: '800',
  xl: '1400',
};
